module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICI2MTc1NDc2ODAwN2I1OTVlNGMxZDUzN2Q0MzY5OWM1Yi5zdmciOw=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thaibank/gsb.svg
// module id = 624
// module chunks = 1